
const newVirtualStationLatLon = state => state.newVirtualStationLatLon

export {
    newVirtualStationLatLon
}